module.exports = __webpack_public_path__ + "static/media/pancard.bd10ae58.png";